import {DiscountLevelFilter} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterFlyoutDiscountLevel} from '@aboutyou/ui-components';
import React from 'react';
import {useDiscountFilterSection} from '../../shared/useDiscountFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: DiscountLevelFilter;
  resetFilter: (slug: string) => void;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    singleSelectOnly?: boolean;
  }) => void;
  hide: VoidFunction;
  isOpen: boolean;
  open: VoidFunction;
  submit: VoidFunction;
};

export const FilterSectionDiscount: React.FC<Props> = ({
  activeFilters,
  data,
  setFilter,
  open,
  isOpen,
  hide,
  submit,
}) => {
  const {
    discountLevelFilterLabel,
    discountLevelFilterSlug,
    activeDiscountFilterValue,
    discountLevelOptions,
    handleApplyDiscount,
  } = useDiscountFilterSection({
    data,
    activeFilters,
    setFilter,
  });

  if (
    !discountLevelFilterLabel ||
    !discountLevelFilterSlug ||
    !discountLevelOptions
  )
    return null;

  return (
    <FilterFlyoutDiscountLevel
      activeOptionId={activeDiscountFilterValue}
      label={discountLevelFilterLabel}
      onSelect={handleApplyDiscount}
      options={discountLevelOptions}
      open={open}
      hide={hide}
      submit={submit}
      isOpen={isOpen}
      showAsRadioGroup
    />
  );
};
